/**
 * Canonical risk factor labels and sub-check row labels.
 * Used by RisksTag and test utilities.
 */

export const FACTOR_LABELS = {
  targetCardinality: 'Target Cardinality',
  valueComplexity: 'Value Complexity',
  constraintLogic: 'Constraint Logic',
  changeFrequency: 'Change Frequency',
} as const;

export const SUBCHECK_LABELS = {
  rolloutTargets: 'Rollout targets',
  size: 'Size',
  keyValuePairs: 'Key Value Pairs',
  jsonDepth: 'JSON Depth',
  numberOfConstraints: 'Number of constraints',
  groupsPerSegP: 'Groups / SegP',
  numberOfChanges: 'Number of changes made in last 60 days',
} as const;
